import {
  ADVISERS_RECEIVE_CATEGORIES,
} from '../actions';

const INIT_STATE = {};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADVISERS_RECEIVE_CATEGORIES:
      return {...state, ...action.payload};
    default:
      return state;
  }
};
